var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _g3, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWilliams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 24,
    viewBox: "0 0 119 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1818 11.3466V4.39996H100.478V11.2764C100.478 13.0592 101.332 13.9096 102.636 13.9096C103.941 13.9096 104.794 13.0968 104.794 11.3644V4.39996H108.091V11.2563C108.091 15.251 105.933 17 102.603 17C99.273 17 97.1818 15.2172 97.1818 11.3448",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 4.39996C92.5118 4.39996 95.3636 7.22294 95.3636 10.7C95.3636 14.177 92.5118 17 89 17C85.4882 17 82.6364 14.177 82.6364 10.7C82.6364 7.22294 85.4882 4.39996 89 4.39996ZM89 6.74054C91.2072 6.74054 92.9988 8.51471 92.9988 10.7C92.9988 12.8852 91.2072 14.6593 88.9997 14.6593C86.7923 14.6593 85.0007 12.8852 85.0007 10.7C85.0007 8.51471 86.7923 6.74054 88.9992 6.74054H89Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4065 11.1947C79.5693 11.3955 79.8229 11.3841 79.9335 11.1286L82.6026 4.9628C82.6521 4.84855 82.6468 4.71286 82.5887 4.60419C82.5306 4.49552 82.4279 4.42938 82.3173 4.42939L78.6001 4.42939C78.4785 4.42613 78.3666 4.50602 78.3147 4.63318C77.5132 6.54722 77.9988 9.45743 79.4065 11.1947Z",
    fill: "url(#paint0_linear_103_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4479 16.8026C78.9407 14.0707 78.8422 11.045 77.8589 8.77351L76.0666 4.63319C76.0125 4.50834 75.9021 4.42947 75.7812 4.42947L72.0641 4.42947C71.9535 4.42946 71.8508 4.4956 71.7927 4.60427C71.7346 4.71294 71.7293 4.84863 71.7788 4.96288C71.7788 4.96288 76.7793 16.5158 76.9051 16.8049C77.0176 17.0637 77.3033 17.0672 77.4479 16.8026Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_103_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4715 16.9318H62.5212C61.5807 16.9318 60.8182 16.0815 60.8182 15.0327C60.8182 13.9837 61.5805 13.1332 62.5212 13.1326L66.4594 13.1304C67.1073 13.1301 67.706 13.5156 68.0295 14.1415L69.4715 16.9318Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1088 12.0622L65.584 5.34982C66.0542 4.4415 67.0958 4.13029 67.9102 4.65471C68.7249 5.17921 69.0043 6.34068 68.5344 7.24939L66.5669 11.0539C66.2433 11.6798 65.6445 12.0652 64.9967 12.0647L62.1088 12.0622Z",
    fill: "#FF3C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5827 7.38617L73.0579 14.0986C73.5282 15.0069 73.2491 16.1683 72.4346 16.6928C71.62 17.2173 70.5783 16.9063 70.1076 15.9981L68.1367 12.1958C67.8125 11.5703 67.8126 10.7993 68.1369 10.1739L69.5827 7.38617Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7833 16V4.8H60.8233V6.72H55.8953V9.424H60.4393V11.344H55.8953V16H53.7833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2322 9.90561C48.0826 9.84088 47.935 9.78001 47.7921 9.72101C46.9348 9.36727 46.2405 9.08081 46.2405 8.43391C46.2405 7.86799 46.6455 7.5283 47.3882 7.5283C48.1308 7.5283 48.806 7.86799 49.5486 8.47179L50.8988 6.4717C50.0548 5.75479 48.9072 5 47.3545 5C45.0591 5 43.5062 6.4717 43.5062 8.5472C43.5062 10.3963 44.9578 11.3396 46.173 11.868C46.2462 11.8997 46.3193 11.931 46.3918 11.9621C47.3561 12.3754 48.2322 12.751 48.2322 13.4528C48.2322 14.0189 47.8269 14.3963 46.9157 14.3963C46.0717 14.3963 45.2279 14.0189 44.3165 13.2264L43 15.4152C44.0126 16.3585 45.5653 17 46.8481 17C49.5486 17 51 15.4152 51 13.3397C51 11.2642 49.5486 10.3963 48.2322 9.90561Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2322 9.90561C48.0826 9.84088 47.935 9.78001 47.7921 9.72101C46.9348 9.36727 46.2405 9.08081 46.2405 8.43391C46.2405 7.86799 46.6455 7.5283 47.3882 7.5283C48.1308 7.5283 48.806 7.86799 49.5486 8.47179L50.8988 6.4717C50.0548 5.75479 48.9072 5 47.3545 5C45.0591 5 43.5062 6.4717 43.5062 8.5472C43.5062 10.3963 44.9578 11.3396 46.173 11.868C46.2462 11.8997 46.3193 11.931 46.3918 11.9621C47.3561 12.3754 48.2322 12.751 48.2322 13.4528C48.2322 14.0189 47.8269 14.3963 46.9157 14.3963C46.0717 14.3963 45.2279 14.0189 44.3165 13.2264L43 15.4152C44.0126 16.3585 45.5653 17 46.8481 17C49.5486 17 51 15.4152 51 13.3397C51 11.2642 49.5486 10.3963 48.2322 9.90561Z",
    stroke: "white",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2727 16.8H30.9716V5.16362H35.267C36.4526 5.16362 37.4735 5.39658 38.3295 5.86249C39.1894 6.32461 39.8522 6.99128 40.3182 7.86249C40.7841 8.72991 41.017 9.76779 41.017 10.9761C41.017 12.1882 40.7841 13.2299 40.3182 14.1011C39.856 14.9723 39.195 15.6409 38.3352 16.1068C37.4754 16.5689 36.4545 16.8 35.2727 16.8ZM33.7841 14.4023H35.1647C35.8163 14.4023 36.3674 14.2924 36.8182 14.0727C37.2727 13.8492 37.6155 13.4875 37.8466 12.9875C38.0814 12.4837 38.1988 11.8132 38.1988 10.9761C38.1988 10.139 38.0814 9.47234 37.8466 8.97612C37.6117 8.47612 37.2651 8.11628 36.8068 7.89658C36.3522 7.67309 35.7916 7.56135 35.125 7.56135H33.7841V14.4023Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9091 4.39996C25.4209 4.39996 28.2727 7.22294 28.2727 10.7C28.2727 14.177 25.4209 17 21.9091 17C18.3973 17 15.5455 14.177 15.5455 10.7C15.5455 7.22294 18.3973 4.39996 21.9091 4.39996ZM21.9091 6.74054C24.1163 6.74054 25.9079 8.51471 25.9079 10.7C25.9079 12.8852 24.1163 14.6593 21.9089 14.6593C19.7014 14.6593 17.9098 12.8852 17.9098 10.7C17.9098 8.51471 19.7014 6.74054 21.9083 6.74054H21.9091Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_103_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25764 5.61148C5.22824 5.00571 5.70294 4.46941 6.31546 4.41711C9.27837 4.19051 12.592 6.82669 12.6981 10.6097C12.7151 11.216 12.2311 11.7211 11.617 11.7379C11.0029 11.7547 10.4913 11.2769 10.4743 10.6706C10.4039 8.16085 8.21421 6.57094 6.42201 6.65579C5.8084 6.68485 5.2871 6.21731 5.25764 5.61148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19458 15.8895C5.19458 15.283 5.69261 14.7913 6.30694 14.7913C8.87105 14.7913 10.5305 12.7502 10.4797 10.7116C10.4646 10.1053 10.9502 9.60167 11.5643 9.58676C12.1785 9.57179 12.6886 10.0513 12.7037 10.6575C12.7832 13.8456 10.2051 16.9986 6.30694 16.9986C5.69261 16.9986 5.19458 16.496 5.19458 15.8895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3932 8.35492C5.76426 8.35492 5.25439 7.84701 5.25439 7.22051V5.56729C5.25439 4.94073 5.76426 4.41714 6.3932 4.41714C7.02219 4.41714 7.53206 4.94073 7.53206 5.56729V7.22051C7.53206 7.84701 7.02219 8.35492 6.3932 8.35492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39486 11.8238C5.76499 11.8238 5.25439 11.3191 5.25439 10.6973C5.25439 10.0754 5.76499 9.57076 6.39486 9.57076C7.02473 9.57076 7.53538 10.0754 7.53538 10.6973C7.53538 11.3191 7.02473 11.8238 6.39486 11.8238Z",
    fill: "url(#paint1_linear_103_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06622 9.60196C1.68002 9.57676 2.19827 10.0476 2.22376 10.6536C2.33381 13.2696 4.41061 14.8666 6.38258 14.7888C6.99639 14.7646 7.5139 15.2265 7.53842 15.8325C7.56294 16.4385 7.06751 16.9714 6.45369 16.9956C3.24018 17.1223 0.0633648 14.4734 0.000976058 10.7448C-0.024515 10.1388 0.452409 9.6271 1.06622 9.60196Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.931 4.43274L112.163 7.58031L115.838 7.54279C115.838 7.54279 116.659 7.63061 116.659 9.02722C116.659 10.4238 115.963 10.5243 115.963 10.5243L114.445 10.5807L116.525 13.5889C116.525 13.5889 119 12.8119 119 9.039C119 5.26609 116.181 4.39996 116.181 4.39996L109.931 4.43274ZM109.909 10.6064H113.093L117.624 16.9134L114.405 17L109.909 10.6064Z",
    fill: "#FFFFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_106",
    x1: 77.9433,
    y1: 10.243,
    x2: 82.2651,
    y2: 6.22358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_106",
    x1: 6.63372,
    y1: 15.0551,
    x2: 9.34253,
    y2: 11.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0605A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9091,
    height: 12.6,
    fill: "white",
    transform: "translate(82.6364 17) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_103_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9091,
    height: 12.6,
    fill: "white",
    transform: "translate(60.8182 4.39996)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_103_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6,
    height: 12.7273,
    fill: "white",
    transform: "translate(0 17) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWilliams);
export default __webpack_public_path__ + "static/media/Williams.4302b69a9b8af9eb32c6cae7ba799ac3.svg";
export { ForwardRef as ReactComponent };